import { useEffect } from "react";
import Nav from "../nav/Nav";

const Home = () => {
    

  return (
    <>
      <div>
        <div
          className="banner-section-outer position-relative first "
          style={{ height: "100vh" }}
        >
          <video
            className="bg-video"
            playsInline="playsinline"
            autoPlay="autoplay"
            muted="muted"
            loop="loop"
            style={{ zIndex: 0 }}
          >
            <source src="./assets/videos/banner.mp4" type="video/mp4" />
          </video>
          {/* Background Video */}
          <header>
           <Nav />
          </header>
          {/* BANNER SECTION */}
          <section
            className="banner-section position-relative  h-100 d-flex align-items-center justify-content-center"
            style={{ backgroundColor: "#00000086" }}
          >
            <div className="container">
              <h1 className="text-light text-center">
                Elevate Your Future with GazTec
              </h1>
              <p
                className="text-light text-center fs-5 fw-5"
                style={{ fontWeight: 600 }}
              >
                Pioneering Innovative AI, Resilient Cybersecurity, and
                Integrated IT
                <br /> Services
              </p>
            </div>
          </section>
        
          <a href="#section2" className="position-absolute down-arrow">
            <i
              className="fa-solid fa-chevron-down fa-bounce"
              style={{ color: "#5cc9ff" }}
            />
          </a>
        </div>
        <div className="position-relative">
          <div className="dcc-overlay-top">
            <img src="./assets/images/overlay.png" className="img-fluid" />
          </div>
        </div>
        {/* STATISTICS SECTION */}
        <section
          className="statistics_section position-relative  second"
          id="section2"
        >
          <div className="dcc-overlay" />
          <div className="container-fluid align-items-center h-100">
            <div className="row position-relative" style={{ zIndex: 1000 }} >
            
              <div className="col-12">
                <div
                  className="statistics_content mb-5 mt-0 pt-0 text-white"
                  
                >
                  <h3 className="mb-2 text-center my-4">
                    Mitigating Risk, Maximizing Opportunity
                  </h3>
                  <div className="row">
                    <div
                      className="col-lg-12 position-relative"
                      style={{ zIndex: 10000 }}
                    >
                      <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 mb-4">
                          <div
                            className="statistics_box hover-effect aos-init aos-animate"
                            style={{ height: 339 }}
                            
                          >
                            <div className="span_wrapper text-center">
                              <span style={{ fontSize: 20 }}>
                                Halt Cyberattacks at Their Core: Network
                                Strengthening
                              </span>
                              {/* <span class="plus">K+</span> */}
                            </div>
                            <p className="text-size-16 text-white pp text-center">
                              Secure your network with our advanced security
                              solutions to block breaches and protect your data
                            </p>
                            {/* <p class="text-size-16 mb-0 text">Modi tempora inciun aut labore.</p> */}
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 mb-4">
                          <div
                            className="statistics_box hover-effect aos-init aos-animate"
                            style={{ height: 339 }}
                            
                          >
                            <div className="span_wrapper text-center">
                              <span style={{ fontSize: 20 }}>
                                Enhance Your Security Approach: Expert
                                Consulting
                              </span>
                              {/* <span class="plus">K+</span> */}
                            </div>
                            <p className="text-size-16 text-white pp text-center">
                              Leverage insights and expertise from our
                              cybersecurity and IT professionals to create a
                              strong, effective security strategy.
                            </p>
                            {/* <p class="text-size-16 mb-0 text">Modi tempora inciun aut labore.</p> */}
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 mb-4">
                          <div
                            className="statistics_box hover-effect aos-init aos-animate"
                            style={{ height: 339 }}
                            
                          >
                            <div className="span_wrapper text-center">
                              <span style={{ fontSize: 20 }}>
                                Future-Proof IT: Scalable Infrastructure
                              </span>
                              {/* <span class="plus">K+</span> */}
                            </div>
                            <p className="text-size-16 text-white pp text-center">
                              Build resilient IT systems with cloud integration
                              and scalable solutions tailored to your growth.
                            </p>
                            {/* <p class="text-size-16 mb-0 text">Modi tempora inciun aut labore.</p> */}
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 mb-4">
                          <div
                            className="statistics_box hover-effect aos-init aos-animate"
                            style={{ height: 339 }}
                            
                          >
                            <div className="span_wrapper text-center">
                              <span style={{ fontSize: 20 }}>
                                Data-Driven Insights: AI Analytics
                              </span>
                              {/* <span class="plus">K+</span> */}
                            </div>
                            <p className="text-size-16 text-white pp text-center">
                              Protect your business with AI-driven solutions
                              like Darktrace and CrowdStrike. Delivering
                              real-time threat detection, automated response,
                              and phishing protection, customized for robust
                              security
                            </p>
                            {/* <p class="text-size-16 mb-0 text">Modi tempora inciun aut labore.</p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <figure className="statistics_left_shape mb-0 position-absolute top_bottom_shape">
              <img
                src="./assets/images/statistics_left_shape.png"
                alt
                className="img-fluid"
              />
            </figure>
            <figure className="statistics_right_shape mb-0 position-absolute top_bottom_shape">
              <img
                src="./assets/images/statistics_right_shape.png"
                alt
                className="img-fluid"
              />
            </figure>
          </div>
        </section>
        {/* ABOUT US SECTION */}
        <section className="aboutus_section position-relative" id="section4">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div
                  className="aboutus_image"
                  
                  data-aos-delay={500}
                >
                  <figure className="aboutus_main_image mb-0">
                    <img
                      src="./assets/images/aboutus_image.jpg"
                      alt
                      className="img-fluid"
                    />
                  </figure>
                  <figure className="aboutus_image_shape position-absolute mb-0 left_right_shape">
                    <img
                      src="./assets/images/aboutus_image_shape.png"
                      alt
                      className="img-fluid"
                    />
                  </figure>
            
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div
                  className="aboutus_content"
                  
                  data-aos-delay={500}
                >
              
                  <h6>About Us</h6>
                  <h2>GazTecForge Technology Inc.</h2>
                  <p>
                    GazTecForge is a pioneering Research and Development company
                    established with a passion for innovation and a commitment
                    to excellence, we have become a driving force in the world
                    of technology. We lead the charge in revolutionizing
                    Artificial Intelligence, Identity Management, Secure
                    Government Document, Internet of Things, Simulators, and
                    Communication Intelligence, ensuring that our solutions are
                    at the forefront of technological advancement.
                  </p>
                 
                  <div className="btn_wrapper">
                    <a
                      className="text-decoration-none default-btn btn-size-18 hover-effect"
                      href="about.php"
                    >
                      Read More
                      <i className="fa-solid fa-angle-right" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <figure className="aboutus_background_shape mb-0 position-absolute left_right_shape">
              <img src="./assets/images/aboutus_background_shape.jpg" alt />
            </figure>
            <figure className="aboutus_top_shape mb-0 position-absolute top_bottom_shape">
              <img
                src="./assets/images/aboutus_top_shape.png"
                alt
                className="img-fluid"
              />
            </figure>
          </div>
        </section>
        {/* MISSION VISION SECTION */}
        <section className="mission_vision_section position-relative py-2">
          <div className="container">
            <div className="row position-relative" >
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="mission_vision_box hover-effect">
                  <figure>
                    <img
                      src="./assets/images/our_mission_image.png"
                      alt
                      className="img-fluid hover-effect"
                    />
                  </figure>
                  <h4>Our Mission</h4>
                  <p className="mb-0">
                    Our mission is to design, develop, and deliver cutting-edge
                    technology solutions that enhance operational efficiency,
                    safety, and innovation. We are dedicated to supporting our
                    clients and partners in achieving their objectives.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="mission_vision_box hover-effect">
                  <figure>
                    <img
                      src="./assets/images/our_vision_image.png"
                      alt
                      className="img-fluid hover-effect"
                    />
                  </figure>
                  <h4>Our Vision</h4>
                  <p className="mb-0">
                    With a clear vision, we aspire to be at the forefront of
                    technological advancement, creating solutions that empower
                    organizations and government agencies for a better, secure,
                    and connected future.
                  </p>
                </div>
              </div>
              <figure className="mission_vision_background_shape mb-0 position-absolute left_right_shape">
                <img
                  src="./assets/images/mission_vision_background_shape.png"
                  alt
                  className="img-fluid"
                />
              </figure>
            </div>
            <figure className="mission_vision_left_shape mb-0 position-absolute top_bottom_shape">
              <img
                src="./assets/images/mission_vision_left_shape.png"
                alt
                className="img-fluid"
              />
            </figure>
          </div>
        </section>
        {/* WHO WE ARE SECTION */}
        <section
          className="who_we_are_section position-relative pt-4"
          id="section5"
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
                <div
                  className="who_we_are_left_content"
                  
                  data-aos-delay={500}
                >
                  {/**/}
                  <h6 className="text-white">Who We Are</h6>
                  <h2 className="text-white">
                    Discover Our Products and Services
                  </h2>
                  <p>
                    Explore our comprehensive range of AI, Identity Management,
                    Secure Government Document, IoT, simulators, and
                    communication intelligence products and services, designed
                    to transform the way you operate. From predictive analytics
                    to autonomous systems, we have the solutions to meet your
                    unique challenges.
                  </p>
                  <div className="btn_wrapper">
                    <a
                      className="text-decoration-none default-btn-two btn-size-18 hover-effect"
                      href="#"
                    >
                      Get Started
                      <i className="fa-solid fa-angle-right" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12" />
              <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="who_we_are_right_content_wrapper">
                  <div className="video_wrapper position-absolute">
                    <div className="video_icon position-relative">
                      <a
                        className="popup-vimeo"
                        href="http://youtu.be/Cx5aNwnZYDc.mp4"
                      >
                        <figure className="mb-0">
                          <img
                            className="img-fluid thumb"
                            style={{ cursor: "pointer" }}
                            src="./assets/images/who_we_are_video_icon.png"
                            alt
                          />
                        </figure>
                      </a>
                    </div>
                    <div className="content">
                      <h5 className="mb-0 text-white">Watch Video</h5>
                    </div>
                  </div>
                  <div className="testimonials_section p-0 bg-transparent">
                    <div className="owl-carousel owl-theme">
                      <div className="item">
                        <div className="who_we_are_right_content">
                          <div className="who_we_are_rightside">
                            <span>4.6</span>
                            <ul className="list-unstyled">
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                            </ul>
                            <h6>Google Reviews</h6>
                            {/* <p class="text-size-16 mb-0">Dolor sit amet consecteu adiriscing elit.</p> */}
                          </div>
                        </div>
                      </div>
                      <div className="item">
                        <div className="who_we_are_right_content">
                          <div className="who_we_are_rightside">
                            <span>4.6</span>
                            <ul className="list-unstyled">
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                            </ul>
                            <h6>Google Reviews</h6>
                            {/* <p class="text-size-16 mb-0">Dolor sit amet consecteu adiriscing elit.</p> */}
                          </div>
                        </div>
                      </div>
                      <div className="item">
                        <div className="who_we_are_right_content">
                          <div className="who_we_are_rightside">
                            <span>4.6</span>
                            <ul className="list-unstyled">
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                              <li>
                                <i className="fa-solid fa-star" />
                              </li>
                            </ul>
                            <h6>Google Reviews</h6>
                            {/* <p class="text-size-16 mb-0">Dolor sit amet consecteu adiriscing elit.</p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <figure className="who_we_are_image position-absolute mb-0">
              <img
                src="./assets/images/who_we_are_image.gif"
                alt
                className="img-fluid"
              />
            </figure>
            <figure className="who_we_are_left_shape mb-0 position-absolute top_bottom_shape">
              <img
                src="./assets/images/who_we_are_left_shape.png"
                alt
                className="img-fluid"
              />
            </figure>
            <figure className="who_we_are_right_shape mb-0 position-absolute top_bottom_shape">
              <img
                src="./assets/images/who_we_are_right_shape.png"
                alt
                className="img-fluid"
              />
            </figure>
          </div>
        </section>
        {/* COMBO SECTION */}
        <section className="combo_section section" id="section8">
          {/* FAQ'S SECTION */}
          <div className="accordian-section">
            <div className="container ">
              <div className="row">
                <div className="col-xxl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div className="heading position-relative text-left text-white">
                    <h6>FAQ’s</h6>
                    <h2 className="mb-3">Frequently Asked Questions</h2>
                    <p>
                      We understand that every organization is unique. That’s
                      why we don’t offer one-size-fits-all solutions.
                      GazTecForge takes the time to understand your specific
                      requirements and crafts customized strategies that align
                      perfectly with your goals.
                    </p>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 col-lg-6 col-md-12 col-sm-12">
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12 col-sm-12 mb-4"
                      
                    >
                      {/**/}
                      <div className="about-service-section-text accordian-section-inner-text position-relative">
                        <div className="accordian-inner">
                          <div id="accordion1">
                            <div className="accordion-card">
                              <div className="card-header" id="headingFour">
                                <button
                                  className="btn btn-link collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseFour"
                                  aria-expanded="false"
                                  aria-controls="collapseFour"
                                >
                                  Advanced AI Solutions
                                </button>
                              </div>
                              <div
                                id="collapseFour"
                                className="collapse"
                                aria-labelledby="headingFour"
                              >
                                <div className="card-body">
                                  <p className="text-size-16 text-left mb-0 p-0">
                                    Our team of experts specializes in
                                    developing advanced AI algorithms and
                                    machine learning models. We create
                                    intelligent systems that can learn, adapt,
                                    and enhance your operations.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="accordion-card">
                              <div className="card-header" id="headingFive">
                                <button
                                  className="btn btn-link collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseFive"
                                  aria-expanded="false"
                                  aria-controls="collapseFive"
                                >
                                  IoT for a Connected World
                                </button>
                              </div>
                              <div
                                id="collapseFive"
                                className="collapse"
                                aria-labelledby="headingFive"
                              >
                                <div className="card-body">
                                  <p className="text-size-16 text-left mb-0 p-0">
                                    The Internet of Things is transforming how
                                    we collect and utilize data. GazTecForge 's
                                    IoT solutions provide real-time insights,
                                    allowing you to make informed decisions and
                                    optimize your processes.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="accordion-card">
                              <div className="card-header" id="headingSix">
                                <button
                                  className="btn btn-link collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseSix"
                                  aria-expanded="false"
                                  aria-controls="collapseSix"
                                >
                                  Simulators for Realistic Training
                                </button>
                              </div>
                              <div
                                id="collapseSix"
                                className="collapse"
                                aria-labelledby="headingSix"
                              >
                                <div className="card-body">
                                  <p className="text-size-16 text-left mb-0 p-0">
                                    Enhance safety and readiness with our
                                    cutting-edge simulators. Whether it's first
                                    responders, defense personnel, or law
                                    enforcement, our simulators offer immersive,
                                    realistic training experiences.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="accordion-card">
                              <div className="card-header" id="headingSeven">
                                <button
                                  className="btn btn-link collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseSeven"
                                  aria-expanded="false"
                                  aria-controls="collapseSeven"
                                >
                                  Communication Intelligence
                                </button>
                              </div>
                              <div
                                id="collapseSeven"
                                className="collapse"
                                aria-labelledby="headingSeven"
                              >
                                <div className="card-body">
                                  <p className="text-size-16 text-left mb-0 p-0">
                                    Our communication intelligence solutions are
                                    designed to ensure secure, efficient, and
                                    intelligent communication across a wide
                                    range of applications.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <figure className="mb-0 faq_right_shape position-absolute top_bottom_shape">
              <img
                src="./assets/images/faq_right_shape.png"
                alt
                className="img-fluid"
              />
            </figure>
          </div>
        </section>
        {/* BLOG SECTION */}
        <section
          className="team_section portfolio_section"
          style={{ display: "none" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="team_content">
                  <h6>Our Blog</h6>
                  <h2>Latest Events &amp; News</h2>
                </div>
              </div>
            </div>
            <div className="row aos-init" >
              <div className="owl-carousel owl-theme">
                <div className="item">
                  <div className="team_box hover-effect">
                    <figure>
                      <img
                        src="./assets/images/team_image1.jpg"
                        alt
                        className="img-fluid"
                      />
                    </figure>
                    <h5>Latest Ai Programming</h5>
                    <p className="text-size-16">Dubai</p>
                    <div className="team_social_icons">
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-facebook-f hover-effect"
                          aria-hidden="true"
                        />
                      </a>
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-twitter hover-effect"
                          aria-hidden="true"
                        />
                      </a>
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-linkedin-in  hover-effect mr-0"
                          aria-hidden="true"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="team_box hover-effect">
                    <figure>
                      <img
                        src="./assets/images/team_image2.jpg"
                        alt
                        className="img-fluid"
                      />
                    </figure>
                    <h5>Technology Benefits</h5>
                    <p className="text-size-16">Africa</p>
                    <div className="team_social_icons">
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-facebook-f hover-effect"
                          aria-hidden="true"
                        />
                      </a>
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-twitter hover-effect"
                          aria-hidden="true"
                        />
                      </a>
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-linkedin-in  hover-effect mr-0"
                          aria-hidden="true"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="team_box hover-effect">
                    <figure>
                      <img
                        src="./assets/images/team_image3.jpg"
                        alt
                        className="img-fluid"
                      />
                    </figure>
                    <h5>New Genaration Ai</h5>
                    <p className="text-size-16">USA</p>
                    <div className="team_social_icons">
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-facebook-f hover-effect"
                          aria-hidden="true"
                        />
                      </a>
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-twitter hover-effect"
                          aria-hidden="true"
                        />
                      </a>
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-linkedin-in  hover-effect mr-0"
                          aria-hidden="true"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="team_box hover-effect">
                    <figure>
                      <img
                        src="./assets/images/team_image2.jpg"
                        alt
                        className="img-fluid"
                      />
                    </figure>
                    <h5>Technology Benefits</h5>
                    <p className="text-size-16">Africa</p>
                    <div className="team_social_icons">
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-facebook-f hover-effect"
                          aria-hidden="true"
                        />
                      </a>
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-twitter hover-effect"
                          aria-hidden="true"
                        />
                      </a>
                      <a href="#" className="text-decoration-none">
                        <i
                          className="fa-brands fa-linkedin-in  hover-effect mr-0"
                          aria-hidden="true"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <figure className="team_left_shape mb-0 position-absolute top_bottom_shape">
              <img
                src="./assets/images/team_left_shape.png"
                alt
                className="img-fluid"
              />
            </figure>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
